/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconvertergenerating2Inputs */

const en_formatconvertergenerating2 = /** @type {(inputs: Formatconvertergenerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI is rearranging…`)
};

const de_formatconvertergenerating2 = /** @type {(inputs: Formatconvertergenerating2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI ordnet neu an…`)
};

/**
* | output |
* | --- |
* | "AI is rearranging…" |
*
* @param {Formatconvertergenerating2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconvertergenerating2 = /** @type {((inputs?: Formatconvertergenerating2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconvertergenerating2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconvertergenerating2(inputs)
	return de_formatconvertergenerating2(inputs)
});
export { formatconvertergenerating2 as "formatConverterGenerating" }